var _rect, _path, _path2, _rect2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftCardEmailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 56,
    viewBox: "0 0 74 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "svg-primary-fill",
    x: 16,
    y: 4,
    width: 42,
    height: 27,
    rx: 4,
    fill: "#E2231A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svg-contrast-stroke",
    d: "M23 11h14",
    stroke: "#fff",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "svg-contrast-stroke svg-faded",
    d: "M23 17h9",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "svg-dark-stroke",
    x: 6,
    y: 18,
    width: 62,
    height: 34,
    rx: 5,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "svg-dark-stroke",
    d: "M7 20l30 18 30-18",
    fill: "none",
    stroke: "#1a1a1a",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftCardEmailed);
export default __webpack_public_path__ + "static/media/gift-card-emailed.6c54dbe6e02bdbecd25fcaaa5753db24.svg";
export { ForwardRef as ReactComponent };